import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { UserPlus, Camera, CreditCard, Printer, ScanLine, ShieldCheck } from "lucide-react";

const STEPS = [
  { icon: UserPlus, t: "Crie sua conta grátis", d: "Cadastro em segundos com e-mail ou Google. Sem cartão, sem pegadinha." },
  { icon: Camera, t: "Anuncie o carro (grátis)", d: "Adicione fotos, preço, KM e detalhes. O anúncio entra na vitrine na hora — e os interessados falam com você pelo chat seguro, sem expor seu telefone." },
  { icon: CreditCard, t: "Assine o Kit de Divulgação com QR", d: "Assinatura trimestral de R$ 29,00 (a cada 3 meses) que libera o QR Code exclusivo e 3 materiais prontos: Cartaz A4, Cartão Postal e Cartão de Visita — todos com o QR do seu anúncio. Cancele quando quiser." },
  { icon: Printer, t: "Baixe e imprima o modelo", d: "Baixe em PNG ou PDF, escolha cor e foto, imprima o Cartaz A4 pro vidro ou os cartões pra entregar na mão. Pronto para vender." },
  { icon: ScanLine, t: "Quem passa na rua escaneia", d: "Ao apontar a câmera no QR, o interessado cai direto no seu anúncio — com fotos, preço e chat seguro." },
  { icon: ShieldCheck, t: "Contato protegido", d: "Seu telefone fica oculto. Toda conversa acontece pelo chat seguro do PicCar." },
];

export default function ComoFunciona() {
  const navigate = useNavigate();
  return (
    <div data-testid="como-page">
      <section className="bg-obsidian text-white py-20 px-5 sm:px-8">
        <div className="max-w-4xl mx-auto">
          <p className="overline text-blaze mb-3">Simples assim</p>
          <h1 className="font-heading font-900 text-4xl md:text-6xl leading-[0.95]">Anúncio grátis.<br />Você só paga o <span className="text-blaze">QR</span>.</h1>
          <p className="mt-6 text-lg text-white/70 max-w-2xl">No PicCar anunciar não custa nada e seu carro aparece pra todo mundo na busca. O único item pago é o Kit de Divulgação com QR (assinatura trimestral): o QR Code exclusivo do PicCar mais os 3 materiais pra divulgar o carro na rua.</p>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-5 sm:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {STEPS.map((s, i) => (
            <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.06 }}
              className="bg-white border border-border rounded-sm p-8 relative" data-testid={`step-${i}`}>
              <span className="absolute top-6 right-6 font-heading font-900 text-5xl text-secondary">{i + 1}</span>
              <div className="w-12 h-12 rounded-sm bg-obsidian flex items-center justify-center"><s.icon className="w-6 h-6 text-blaze" strokeWidth={1.5} /></div>
              <p className="mt-5 font-heading font-800 text-xl">{s.t}</p>
              <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{s.d}</p>
            </motion.div>
          ))}
        </div>

        <div className="mt-16 bg-blaze rounded-sm p-10 md:p-14 text-center text-white">
          <h2 className="font-heading font-900 text-3xl md:text-4xl">Bora vender seu carro?</h2>
          <Button className="mt-6 h-14 px-10 bg-white text-obsidian hover:bg-obsidian hover:text-white font-700 rounded-sm text-base" onClick={() => navigate("/anunciar")} data-testid="como-cta-btn">
            Anunciar grátis agora
          </Button>
        </div>
      </section>
    </div>
  );
}
